import { ImportType } from 'modules/domains/adminApp';
import { Fractions } from '../types';
import { isFeatureAffected } from './isFeatureAffected';

export const getAffectedIds = (idFractions: Fractions, importType: ImportType) =>
  Object.entries(idFractions)
    .filter(([, fractionEnabled]) => isFeatureAffected(fractionEnabled, importType))
    .map(([projectId]) => parseInt(projectId, 10));
